// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1pMt3","assignButton":"CreateEditEquipmentSchedule_assignButton__3XW-Z"};